/**
 * 対応メモ (spec submission-management.md §7、AC-PSM-057a / 069) の入力の事前検証。
 *
 * 判定の正は backend の domain (`PlanHandlingMemo` の生成時検証)。ここは送信前に
 * 同じ規則で弾いて spec の文言を入力欄の下に出すための UX 目的の重複。
 * client と server の判定がずれると、client が
 * 通した入力を server が InvalidArgument で拒否し、AC-PSM-059 (保存失敗) の文言が
 * 出てしまうため、空白の定義と数え方を backend と揃える:
 *
 * - 前後の空白は Unicode White_Space で除く (backend `strings.TrimFunc(s, unicode.IsSpace)`)。
 *   `String.prototype.trim` は U+FEFF を除き U+0085 を除かないので使わない
 * - 文字数は Unicode code point で数える (backend `utf8.RuneCountInString`)。
 *   UTF-16 長だと絵文字が 2 文字になる
 */

/** 対応メモの上限文字数 (AC-PSM-068 / 069)。 */
export const HANDLING_MEMO_MAX_LENGTH = 100

const SURROUNDING_WHITE_SPACE = /^\p{White_Space}+|\p{White_Space}+$/gu

/** 前後の Unicode White_Space を除いた本文 (= 保存される本文)。 */
export function normalizeHandlingMemoBody(raw: string): string {
  return raw.replace(SURROUNDING_WHITE_SPACE, '')
}

/** code point 単位の文字数。 */
export function countHandlingMemoLength(s: string): number {
  return Array.from(s).length
}

export type HandlingMemoValidationError = 'empty' | 'tooLong'

/**
 * 送信前の検証。問題が無ければ undefined。
 * 空 (前後の空白を除いて 0 文字) を先に判定し、次に上限超過を判定する。
 */
export function validateHandlingMemo(
  raw: string,
): HandlingMemoValidationError | undefined {
  const body = normalizeHandlingMemoBody(raw)
  if (body === '') return 'empty'
  if (countHandlingMemoLength(body) > HANDLING_MEMO_MAX_LENGTH) return 'tooLong'
  return undefined
}
